define('viewModels/privileged/composer/VisibilityConditionMixinProvider',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/privileged/composer/forms/formEditor/VisibilityConditionPicker',
    'enums/composer/visibilityConditionOperation'
], function(
    ko,
    _,
    VisibilityConditionPicker,
    visibilityConditionOperation
) {
    "use strict";

    /*
     *  VisibilityConditionMixinProvider is used to provide visibility condition functionality across questions and groups

     * Arguments:
         viewModel - the viewModel that the functions will be attached to

     * Usage example:
         var viewModel = self.subView(ExampleViewModel, data);
         var mixinProvider = new VisibilityConditionMixinProvider(viewModel);
     */

    var VisibilityConditionMixinProvider = function (viewModel) {
        var mixin = this;

        function subscribeToAnswers(viewModel, visibilitySubscriptions, answerObservables, predicateAnswers, operation) {
            if (visibilitySubscriptions) {
                visibilitySubscriptions.dispose();
                visibilitySubscriptions = null;
            }

            var computeVisibility = function () {
                var answerValues = arguments;
                var findOperation = operation === visibilityConditionOperation.AND ? _.every : _.some;
                var predicateAnswersClone = predicateAnswers.slice(0);
                var isVisible = findOperation(answerValues, function(answerValue) {
                    return predicateAnswersClone.shift() === answerValue;
                });

                viewModel.visibilityConditionVisible(isVisible);
            };

            // Compute the initial visibility
            computeVisibility.apply(viewModel, _.map(answerObservables, ko.unwrap));

            // Update visibility anytime there is a change to an answer that this model cares about
            visibilitySubscriptions = viewModel.multiSubscribe(answerObservables, computeVisibility);
        }

        mixin.addVisibilityConditions = function (questionSet, model, getQuestionOptions, formEditorState) {
            // Add properties to edit visibility conditions during edit mode
            viewModel.visibilityConditionEnabled = ko.observable(!!ko.unwrap(model.visibilityCondition));
            viewModel.visibilityConditionPicker = null;

            if (!viewModel.visibilityConditionVisible) {
                viewModel.visibilityConditionVisible = ko.observable(true);
            }

            var getPredicateViews = function (viewModel) {
                if (viewModel.visibilityConditionPicker &&
                    viewModel.visibilityConditionPicker.predicateViews()) {
                    return viewModel.visibilityConditionPicker.predicateViews();
                }
                return [];
            };

            viewModel.getPredicateViewsWithQuestionGroup = function(questionGroupIndex) {
                return _.filter(getPredicateViews(viewModel), function (predicateView) {
                    return predicateView.selectedQuestion() &&
                            predicateView.selectedQuestion().questionGroupIndex() === questionGroupIndex;
                });
            };

            viewModel.getPredicateViewsWithQuestion = function(questionIndex) {
                return _.filter(getPredicateViews(viewModel), function (predicateView) {
                    return predicateView.selectedQuestion() &&
                            predicateView.selectedQuestion().index() === questionIndex;
                });
            };

            var updateVisibilityConditionEnabled = function(isEnabled, ignoreModification) {
                if (isEnabled) {
                    if (!ko.unwrap(model.visibilityCondition)) {
                        model.addVisibilityCondition();
                    }

                    var questionGroupIndex = ko.unwrap(model.questionGroupIndex) || ko.unwrap(model.index);
                    viewModel.visibilityConditionPicker = viewModel.subView(VisibilityConditionPicker, model.visibilityCondition, formEditorState, getQuestionOptions, questionSet, questionGroupIndex);
                    if (!ignoreModification) { formEditorState.isModified(true); }
                } else {
                    model.visibilityCondition(null);
                    viewModel.visibilityConditionPicker = null;
                }
            };

            viewModel.subscribe(viewModel.visibilityConditionEnabled, updateVisibilityConditionEnabled);
            updateVisibilityConditionEnabled(viewModel.visibilityConditionEnabled(), true);

            // Add properties to enforce visibility conditions during scoring/preview
            var visibilitySubscriptions = null;

            // Set up subscriptions to answers for visibility conditions
            viewModel.computed(function() {
                var visibilityCondition = ko.unwrap(model.visibilityCondition);
                if (!viewModel.isEditMode() && viewModel.visibilityConditionEnabled() && visibilityCondition) {
                    var answerObservables = [];
                    var predicateAnswers = [];
                    var unwrappedQuestionSet = ko.unwrap(questionSet);
                    if (viewModel.visibilityConditionPicker && viewModel.visibilityConditionPicker.predicateViews()) {
                        _.each(viewModel.visibilityConditionPicker.predicateViews(), function (predicateView) {
                            var questionId = predicateView.selectedQuestion().id;
                            var answer = unwrappedQuestionSet[questionId].answerId;
                            answerObservables.push(answer);

                            var answerId = predicateView.selectedAnswer().id;
                            predicateAnswers.push(answerId);
                        });
                    }

                    var operation = ko.unwrap(visibilityCondition.combiningOperation);
                    ko.ignoreDependencies(subscribeToAnswers, mixin, [viewModel, visibilitySubscriptions, answerObservables, predicateAnswers, operation]);
                }
            });
        };
    };

    return VisibilityConditionMixinProvider;
});
